import Vue from "vue";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import Loading from "@/components/widgets/Loading.vue";
import Delete from "@/components/alerts/sweet-alert/alertDelete.vue";
import SortedTablePlugin from "vue-sorted-table";
import Paginate from "@/components/widgets/pagination.vue";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>',
});

export default {
  components: {
    Loading,
    Delete,
    DatePicker,
    Paginate,
  },

  data() {
    return {
      sum: {
        all: 0,
        month: 0,
        year: 0,
      },

      totalItem: 0,

      // filters (ตรงกับ template)
      keyword: "",
      keyword_status: null,
      keyword_startdate: null,
      keyword_enddate: null,

      // misc
      role: "",
      branch: "",

      loading: false,
      currentPage: 1,
      currentData: {},
      sortBy: "document_no",
      sortDesc: true,
      receiveStockLoadingUuid: null,

      fields: [
        {
          key: "document_no",
          label: "เลขที่ใบสั่งซื้อ",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "supplier_detail",
          label: "ลูกค้า",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "purchase_date",
          label: "วันที่สั่งซื้อ",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "purchase_date",
          label: "วันที่สั่งซื้อ",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "description",
          label: "ชื่อรายการ",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "grandtotal",
          label: "จำนวนเงิน",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "creator_detail.name",
          label: "ผู้จัดทำ",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "status",
          label: "สถานะ",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "action",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          class: "text-right",
        },
      ],

      items: [],
    };
  },

  computed: {
    rows() {
      return this.items.length;
    },
  },

  methods: {
    getSupplierCompany(item) {
      const supplier = item?.supplier_detail || item?.supplier || {};
      const company =
        supplier?.company_name ||
        supplier?.company ||
        item?.supplier_company_name ||
        item?.company_name ||
        "";
      if (company) return company;
      return this.getSupplierName(item);
    },

    getSupplierName(item) {
      const supplier = item?.supplier_detail || item?.supplier || {};
      return (
        supplier?.name ||
        item?.supplier_name ||
        item?.supplier_fullname ||
        item?.vendor_name ||
        "-"
      );
    },

    toThaiDate(v) {
      if (!v) return "-";
      const d = new Date(v);
      if (Number.isNaN(d.getTime())) return "-";
      return d.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },

    toMoney(v) {
      const n = Number(v);
      if (Number.isNaN(n)) return "0.00";
      return n.toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    calcNetTotal(item) {
      const subtotal = Number(item?.subtotal ?? 0);
      const discount = Number(item?.discount ?? 0);
      const base = subtotal - discount;

      const vatable = Number(item?.vatable ?? 0) === 1;
      const vatRate = 0.07; // 7%
      const vatAmount = vatable ? (base * vatRate) : 0;

      const net = base + vatAmount;
      return Number.isNaN(net) ? 0 : net;
    },

    statusText(statusValue) {
      const found = this.purchaseStatusOption.find((x) => x.value === statusValue);
      return found ? found.text : (statusValue ?? "-");
    },

    onResetFilters() {
      this.keyword = "";
      this.keyword_status = null;
      this.keyword_startdate = null;
      this.keyword_enddate = null;
      this.onInitData(1);
    },

    // ===== auth/role =====
    async getRole() {
      try {
        const res = await this.$store.dispatch("Auth/getRole", {}, { root: true });
        this.role = res?.data?.role || "";
        this.branch = res?.data?.branch_id || "";
      } catch (e) {
        this.role = "";
        this.branch = "";
      }
    },

    // ===== role helpers (ใช้ซ่อนปุ่ม) =====
    normalizeRole(v) {
      return String(v || "").trim().toLowerCase();
    },

    hasRole(roles = []) {
      const r = this.normalizeRole(this.role);
      return roles.map(this.normalizeRole).includes(r);
    },

    isPending(item) {
      return this.statusText(item.status) === "รออนุมัติ";
    },
    isSuccess(item) {
      return Number(item?.status) === 3;
    },
    isCancelled(item) {
      return this.statusText(item.status) === "ยกเลิก";
    },
    isRejected(item) {
      return this.statusText(item.status) === "ไม่อนุมัติ";
    },

    isLocked(item) {
      // ล็อก = อนุมัติ(จัดซื้อสำเร็จ) หรือ ไม่อนุมัติ หรือ ยกเลิก
      return this.isSuccess(item) || this.isRejected(item) || this.isCancelled(item);
    },

    showEdit(item) {
      // แก้ไขได้เฉพาะ role ที่กำหนด + สถานะยังไม่ล็อก
      const roleOk = this.hasRole(["Admin", "Branch Admin", "Branch Admin assistant"]);
      return roleOk && !this.isLocked(item);
    },

    onEdit(item) {
      const id = item.uuid || item.id;
      if (!id) return;
      this.$router.push(`/purchase-list/${id}`);
    },

    // ===== show/hide (ใช้กับ v-if ที่ปุ่ม) =====
    showApprove(item) {
      return this.hasRole(["Admin", "Branch Admin", "Branch Admin assistant"]) && this.isPending(item);
    },
    showReject(item) {
      return this.hasRole(["Admin", "Branch Admin", "Branch Admin assistant"]) && this.isPending(item);
    },
    showCancel(item) {
      const roleOk = this.hasRole(["Admin", "Branch Admin", "Branch Admin assistant"]);
      const statusOk = !this.isSuccess(item) && !this.isCancelled(item);
      return roleOk && statusOk;
    },
    showReceiveStock(item) {
      const roleOk = this.hasRole(["Admin", "Branch Admin", "Branch Admin assistant"]);
      return roleOk && this.canReceiveStock(item);
    },

    isReceivedStock(item) {
      return item?.is_received_stock === true || Number(item?.is_received_stock) === 1;
    },

    canReceiveStock(item) {
      return Number(item?.status) === 3 && !this.isReceivedStock(item) && !!item?.uuid;
    },

    resolveReceiveStockPayload(responseData = {}) {
      const payload = responseData?.data || responseData || {};
      const received = Array.isArray(payload?.received) ? payload.received : [];
      const skipped = Array.isArray(payload?.skipped) ? payload.skipped : [];
      const receivedCount = Number(payload?.received_count ?? received.length ?? 0);
      return { receivedCount, received, skipped };
    },

    formatReceiveItem(item = {}) {
      return (
        item?.sku_code ||
        item?.full_code ||
        item?.code ||
        item?.sku_uuid ||
        item?.name ||
        item?.description ||
        "ไม่ทราบ SKU"
      );
    },

    escapeHtml(value = "") {
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },

    buildReceiveStockSuccessHtml(payload = {}) {
      const receivedCount = Number(payload?.receivedCount || 0);
      const received = Array.isArray(payload?.received) ? payload.received : [];
      const skipped = Array.isArray(payload?.skipped) ? payload.skipped : [];

      const receivedHtml = received.length
        ? `<ul class="text-left pl-3 mb-2">${received
          .map((item) => `<li>${this.escapeHtml(this.formatReceiveItem(item))}</li>`)
          .join("")}</ul>`
        : `<div class="text-left text-gray-500 mb-2">ไม่มีรายการรับเข้า</div>`;

      const skippedHtml = skipped.length
        ? `<div class="text-left text-warning mt-2">บาง SKU ยังไม่ถูก map ใน stock (miscellaneous_items) จำนวน ${skipped.length} รายการ</div>`
        : "";

      return (
        `<div class="text-left">` +
        `<div class="font-weight-bold mb-1">รับเข้าสต็อคสำเร็จ</div>` +
        `<div class="mb-2">received_count: ${receivedCount}</div>` +
        `<div class="font-weight-bold">รายการ received</div>` +
        `${receivedHtml}` +
        `${skippedHtml}` +
        `</div>`
      );
    },

    getReceiveStockErrorMessage(error) {
      const status = Number(error?.response?.status || 0);
      const apiMessage = error?.response?.data?.message || error?.message || "";

      if (status === 422) {
        return apiMessage || "ยังไม่ถึงสถานะรับเข้า / รับเข้าไปแล้ว / ไม่มีสินค้าที่รับเข้าได้";
      }
      if (status === 401 || status === 403) {
        return apiMessage || "ไม่มีสิทธิ์ทำรายการหรือไม่สามารถทำข้ามสาขาได้";
      }
      if (status >= 500) {
        return "รับเข้าสต็อกไม่สำเร็จ กรุณาติดต่อแอดมิน";
      }
      return apiMessage || "รับเข้าสต็อกไม่สำเร็จ";
    },

    onReceiveStock(item) {
      const uuid = item?.uuid;
      if (!uuid) {
        this.onExceptionHandler("ไม่พบ uuid ของเอกสารใบสั่งซื้อ");
        return;
      }

      this.$swal({
        width: '29rem',
        padding: '1.825em',
        html:
          '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
          '<div class="d-flex flex-column">' +
          '<span class="font-bold text-base py-2.5 text-left">ยืนยันรับเข้าสต็อค?</span>' +
          '<span class="text-base text-left text-gray-500">รายการสินค้าทั้งหมดในใบสั่งซื้อ ' + (item.document_no || '') + ' จะถูกบันทึกเข้าสต็อคของสาขา</span>' +
          '</div></div>',
        showCancelButton: true,
        confirmButtonText: 'ยืนยันรับเข้าสต็อค',
        cancelButtonText: 'ยกเลิก',
        customClass: {
          popup: 'swal2-custom-rounded',
          confirmButton: 'btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal',
          cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal',
          title: 'd-none',
          actions: 'justify-content-end',
        },
        focusConfirm: false,
        allowOutsideClick: false,
      }).then(async (confirm) => {
        if (!confirm.value) return;
        try {
          this.receiveStockLoadingUuid = uuid;
          const response = await Vue.prototype.$axios.post(
            `${Vue.prototype.$host}/api/v1/document/purchases/${uuid}/receive-stock`
          );

          await this.onInitData(this.currentPage);

          const payload = this.resolveReceiveStockPayload(response?.data);
          this.$swal.fire({
            icon: 'success',
            html: this.buildReceiveStockSuccessHtml(payload),
            confirmButtonText: "ตกลง",
            allowOutsideClick: false,
          });
        } catch (error) {
          this.onExceptionHandler(this.getReceiveStockErrorMessage(error));
        } finally {
          this.receiveStockLoadingUuid = null;
        }
      });
    },

    // ===== main loader =====
    async onInitData(currentPage = 1) {
      this.currentPage = currentPage;
      this.loading = true;

      try {
        const page = currentPage || 1;

        const qs = new URLSearchParams();
        qs.set("page", String(page));
        qs.set("keyword", this.keyword || "");
        qs.set("keyword_status", this.keyword_status || "");

        qs.set(
          "keyword_startdate",
          this.keyword_startdate ? moment(this.keyword_startdate).format("YYYY-MM-DD") : ""
        );
        qs.set(
          "keyword_enddate",
          this.keyword_enddate ? moment(this.keyword_enddate).format("YYYY-MM-DD") : ""
        );

        // qs.set("keyword_branch", this.branch || "");

        const url = `${Vue.prototype.$host}/api/v1/document/purchases?${qs.toString()}`;
        const result = await Vue.prototype.$axios.get(url);

        // ✅ FIX: รองรับทั้ง response แบบ wrap และแบบ paginator ตรง (admin มักได้คนละรูป)
        const payload = result?.data || {};
        const paginator = Array.isArray(payload?.data) ? payload : payload?.data;

        // Paginate ต้องการ paginator ตัวที่มี current_page/last_page/to (= paginator) ไม่ใช่ payload ตัวนอก
        this.currentData = paginator || {};
        this.items = paginator?.data || [];
        this.totalItem = paginator?.total || 0;

        // sum (บาง role อาจไม่มี)
        this.sum.all = Number(payload?.sum || 0);
        this.sum.month = Number(payload?.sum_month || 0);
        this.sum.year = Number(payload?.sum_year || 0);
      } catch (error) {
        this.items = [];
        this.totalItem = 0;
        this.currentData = {};
        this.sum = { all: 0, month: 0, year: 0 };

        const msg =
          error?.response?.data?.message ||
          error?.message ||
          "ไม่สามารถโหลดข้อมูลได้";
        if (typeof this.onExceptionHandler === "function") {
          this.onExceptionHandler(msg);
        } else {
          // eslint-disable-next-line no-console
          console.error(msg);
        }
      } finally {
        this.loading = false;
      }
    },

    async generatePurchaseDocument(uuid) {
      try {
        this.loading = true;
        const result = await this.$axios.get(
          this.$host + "/api/v1/downloadPurchasePDF/" + uuid,
          {
            responseType: "blob",
          }
        );

        const blob = new Blob([result.data], { type: "application/pdf" });
        const objectUrl = URL.createObjectURL(blob);
        window.open(objectUrl, "_blank");
      } catch (error) {
        const msg =
          error?.response?.data?.message ||
          error?.message ||
          "ดาวน์โหลดเอกสารไม่สำเร็จ";
        if (typeof this.onExceptionHandler === "function") this.onExceptionHandler(msg);
        else console.error(msg);
      } finally {
        this.loading = false;
      }
    },

    onCreate() {
      this.$router.push("/quotation/create");
    },

    // ===== View =====
    onView(item) {
      if (item.uuid) return this.generatePurchaseDocument(item.uuid);
    },

    // ===== common POST action helper =====
    async postAction(url, payload = null, fallbackMsg = "ทำรายการไม่สำเร็จ") {
      try {
        this.loading = true;
        if (payload) await this.$axios.post(url, payload);
        else await this.$axios.post(url);
        await this.onInitData(this.currentPage);
      } catch (error) {
        const msg =
          error?.response?.data?.message ||
          error?.message ||
          fallbackMsg;
        if (typeof this.onExceptionHandler === "function") this.onExceptionHandler(msg);
        else console.error(msg);
      } finally {
        this.loading = false;
      }
    },

    // ===== Approve/Reject/Cancel actions (ยิง API โลด) =====
    async onApprove(item) {
      const ok = window.confirm(`ยืนยันอนุมัติใบสั่งซื้อ ${item.document_no || ""} ?`);
      if (!ok) return;

      const url = `${this.$host}/api/v1/document/purchases/${item.uuid || item.id}/approve`;
      await this.postAction(url, null, "อนุมัติไม่สำเร็จ");
    },

    async onReject(item) {
      const ok = window.confirm(`ยืนยันปฏิเสธใบสั่งซื้อ ${item.document_no || ""} ?`);
      if (!ok) return;

      const url = `${this.$host}/api/v1/document/purchases/${item.uuid || item.id}/reject`;
      await this.postAction(url, null, "ปฏิเสธไม่สำเร็จ");
    },

    async onCancel(item) {
      const ok = window.confirm(`ยืนยันยกเลิกใบสั่งซื้อ ${item.document_no || ""} ?`);
      if (!ok) return;

      const url = `${this.$host}/api/v1/document/purchases/${item.uuid || item.id}/cancel`;
      await this.postAction(url, null, "ยกเลิกไม่สำเร็จ");
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.onInitData(this.currentPage);
    });
    this.getRole();
  },
};
